var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMerge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 26.2672C24.1333 25.7339 24.1333 24.9339 23.6 24.4005L20.9333 21.7339C20.4 21.2005 19.6 21.2005 19.0667 21.7339C18.5333 22.2672 18.5333 23.0672 19.0667 23.6005L21.7333 26.2672C22.2667 26.8005 23.0667 26.8005 23.6 26.2672ZM11.6 10.6672H14.6667V17.0672C14.6667 17.7339 14.4 18.4005 13.8667 18.9339L8.4 24.4005C7.86667 24.9339 7.86667 25.7339 8.4 26.2672C8.93333 26.8005 9.73333 26.8005 10.2667 26.2672L16.5333 20.0005C17.0667 19.4672 17.3333 18.8005 17.3333 18.1339V10.6672H20.4C20.9333 10.6672 21.3333 10.0005 20.9333 9.46719L16.5333 5.06719C16.2667 4.80052 15.8667 4.80052 15.6 5.06719L11.2 9.46719C10.6667 10.0005 11.0667 10.6672 11.6 10.6672Z",
    fill: "#E6FB66"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMerge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/merge.5cc21ac82a86c610a88d2e898b6fdc23.svg";